document.addEventListener('DOMContentLoaded', function () {
  const formatMap = {
    "MOV HD": "HD MOV",
    "MP4 HD": "HD MP4",
    "MP4 SD": "SD MP4",
    "MOV SD": "SD MOV",
    "MOV HD Hand Motions": "HD MOV Hand Motions",
    "MOV HD Lyrics": "HD MOV Lyrics",
    "MOV HD Instrumental": "HD MOV Instrumental",
    "MOV HD Hand Motions Instrumental": "HD MOV Hand Motions Instrumental",
    "MOV HD Split Track": "HD MOV Split Track",
    "MOV HD Tutorial": "HD MOV Tutorial",
    "MOV SD Instrumental": "SD MOV Instrumental",
    "MOV SD Hand Motions": "SD MOV Hand Motions",
    "MOV SD Split Track": "SD MOV Split Track",
    "MOV SD Tutorial": "SD MOV Tutorial",
    "MP4 HD Instrumental": "HD MP4 Instrumental",
    "MP4 HD Lyrics": "HD MP4 Lyrics",
    "MP4 HD Hand Motions": "HD MP4 Hand Motions",
    "MP4 HD Hand Motions Instrumental": "HD MP4 Hand Motions Instrumental",
    "MP4 HD Split Track": "HD MP4 Split Track",
    "MP4 HD Tutorial": "HD MP4 Tutorial",
    "MP4 SD Instrumental": "SD MP4 Instrumental",
    "MP4 SD Hand Motions": "SD MP4 Hand Motions",
    "MP4 SD Split Track": "SD MP4 Split Track",
    "MP4 SD Tutorial": "SD MP4 Tutorial"
  };

  // Function to format labels dynamically
  function formatLabel(text) {
    const formattedVariant = text
      .split('_')
      .map(word => word.toUpperCase())
      .join(' ');
    return formatMap[formattedVariant] || formattedVariant;
  }

  // Update logic for all sections
  const updateLabelsInSection = (containerSelector, labelSelector) => {
    const containers = document.querySelectorAll(containerSelector);
    containers.forEach(container => {
      const labels = container.querySelectorAll(labelSelector);
      labels.forEach(label => {
        const originalText = label.textContent.trim();
        const formattedText = formatLabel(originalText);
        label.textContent = formattedText;
      });
    });
  };

  // Update labels in display-json sections
  updateLabelsInSection("#display-json", "li");

  // Update labels in aws-links-checkboxes sections
  updateLabelsInSection(".aws-links-container", "label");
});



  // Function to get the current page handle from the URL
  function getPageHandle() {
    const path = window.location.pathname;
    const segments = path.split('/').filter(segment => segment !== '');
    return segments.pop(); // Returns the last segment as the page handle
  }

  // Function to hide the filter label if the page handle matches a filter option
  function hideFilterLabel() {
    const pageHandle = getPageHandle(); // Get the current page handle
    const filterBox = document.querySelector('.kuFilterBox[data-filter="sub_category"]');
    
    if (filterBox) {
      const filterItems = filterBox.querySelectorAll('.klevuFilterOption');
      filterItems.forEach(item => {
        const filterValue = item.getAttribute('data-value').toLowerCase(); // Get the filter value
        if (filterValue === pageHandle.toLowerCase()) {
          item.closest('li').style.display = 'none'; // Hide the corresponding list item
        }
      });
    }
  }

  // Function to wait for Klevu to load, set up observer, and handle scroll events
  function initializeScrollAndObserver() {
    const filterBoxSelector = '.kuFilterBox[data-filter="sub_category"]';
    const maxAttempts = 50; // Maximum number of attempts to check
    let attempts = 0;

    const interval = setInterval(() => {
      const filterBox = document.querySelector(filterBoxSelector);
      if (filterBox || attempts >= maxAttempts) {
        clearInterval(interval);

        if (filterBox) {
          // Initial call to hide the filter label
          hideFilterLabel();

          // Set up MutationObserver to observe changes in the filter box
          const observer = new MutationObserver(() => {
            hideFilterLabel(); // Reapply the logic on DOM changes
          });

          observer.observe(filterBox, {
            childList: true, // Observe child nodes
            subtree: true    // Observe changes in all descendant nodes
          });

          // Set up scroll event listener
          window.addEventListener('scroll', () => {
            hideFilterLabel(); // Reapply the logic on scroll
          });
        }
      }
      attempts++;
    }, 200); // Check every 200 milliseconds
  }

  // Start the process
  initializeScrollAndObserver();
 
document.addEventListener("DOMContentLoaded", function () {
  const collectionMappings = {
    "/collections/song-tracks": {
      selector: '.kuFilterBox[data-filter="product_type"]',
      replacements: {
        "Song Tracks": "Singles" 
      }
    },
    "/collections/games": {
      selector: '.kuFilterBox[data-filter="product_type"]',
      replacements: {
        "Games": "Singles", 
      }
    },
    "/collections/kids-videos": {
      selector: '.kuFilterBox[data-filter="product_type"]',
      replacements: {
        "Mini Movies": "Singles" 
       }
    },
    "/collections/countdowns": {
      selector: '.kuFilterBox[data-filter="product_type"]',
      replacements: {
        "Countdowns": "Singles",
       }
    },
    "/collections/curriculum": {
      selector: '.kuFilterBox[data-filter="product_type"]',
      replacements: {
        "Curriculum": "Singles",
       }
    },
    "/collections/motions": {
      selector: '.kuFilterBox[data-filter="product_type"]',
      replacements: {
        "Motions": "Singles",
       }
    },
  };

  // Initialize observer and text replacements
  function initializeObserverAndReplacements() {
    const maxAttempts = 50;
    let attempts = 0;

    const filterBoxSelector = '.kuFilterBox[data-filter="product_type"]';
    
    const interval = setInterval(() => {
      const filterBox = document.querySelector(filterBoxSelector);
      if (filterBox || attempts >= maxAttempts) {
        clearInterval(interval);

        if (filterBox) {
          // Initial text update
          updateFilterTexts();

          // Set up MutationObserver for dynamic updates
          const observer = new MutationObserver(() => {
            updateFilterTexts();
          });

          // Observe both filter box and body for changes
          observer.observe(filterBox, {
            childList: true,
            subtree: true
          });

          observer.observe(document.body, {
            childList: true,
            subtree: true
          });

          // Handle scroll events
          window.addEventListener('scroll', () => {
            updateFilterTexts();
          });
        }
      }
      attempts++;
    }, 200);
  }

  function updateFilterTexts() {
    try {
      const currentPath = window.location.pathname.toLowerCase();
      console.log('Current path:', currentPath);
      
      Object.entries(collectionMappings).forEach(([path, config]) => {
        if (currentPath.includes(path.toLowerCase())) {
          console.log('Matching path found:', path);
          
          const filterBox = document.querySelector(config.selector);
          if (filterBox) {
            const filterItems = filterBox.querySelectorAll('.kufacet-text');
            console.log('Found filter items:', filterItems.length);
            
            filterItems.forEach(item => {
              const originalText = item.textContent.trim();
              if (config.replacements[originalText]) {
                console.log('Replacing:', originalText, 'with:', config.replacements[originalText]);
                item.textContent = config.replacements[originalText];
              }
            });
          }
        }
      });
    } catch (error) {
      console.error('Error updating filter texts:', error);
    }
  }

  // Start initialization
  initializeObserverAndReplacements();
});